module.exports = __webpack_public_path__ + "img/hamburger.a5f42e2a.svg";